import { range } from 'lodash-es';
import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

import { SkeletonTile } from './Tile.skeleton';

const StyledDiv = styled.div`
  width: 28em;
`;

export const DashboardSkeleton: FC = () => (
  <div className="h-100 d-flex flex-row">
    <div className="bg-lvl1 border-start border-light flex-grow-0 flex-shrink-0">
      <StyledDiv className="pt-4 px-3 pb-3">
        <h2 className="text-nowrap">
          <Skeleton width="10em" />
        </h2>
        <div className="input-group input-group-lg mt-3">
          <em className="icon icon-sm">
            <Skeleton width="1em" />
          </em>
          <label className="form-control form-control-lg" />
        </div>
        <div className="btn-group btn-group-toggle w-100 mt-2">
          <button type="button" className="btn btn-toggle-primary active" data-e2e="byStatus">
            <em className="icon icon-md me-2">
              <Skeleton width="1em" />
            </em>
            <Skeleton width="3em" />
          </button>
          <button type="button" className="btn btn-toggle-primary" data-e2e="byPinned">
            <em className="icon icon-md me-2">
              <Skeleton width="1em" />
            </em>
            <Skeleton width="4em" />
          </button>
          <button type="button" className="btn btn-toggle-primary" data-e2e="byClient">
            <em className="icon icon-md me-2">
              <Skeleton width="1em" />
            </em>
            <Skeleton width="5em" />
          </button>
        </div>
      </StyledDiv>
    </div>
    <div className="flex-grow-1">
      <div className="h-100 overflow-y-auto">
        <div className="p-3 d-flex flex-wrap bg-lvl2 w-100 overflow-y-auto align-content-start">
          <div className="w-100 px-2">
            <div className="d-flex">
              <h2 className="text-truncate" title="All status">
                <Skeleton width="6em" />
              </h2>
            </div>
          </div>
          {range(0, 24).map(idx => (
            <SkeletonTile key={idx} />
          ))}
        </div>
      </div>
    </div>
  </div>
);
